import { useParams, Link } from 'react-router-dom';
import Header from './home/components/Header';
import Footer from './home/components/Footer';
import HowItWorks from './home/components/HowItWorks';
import ServiceAreas from './home/components/ServiceAreas';
import Testimonials from './home/components/Testimonials';
import WhyChooseUs from './home/components/WhyChooseUs';
import QuoteForm from './home/components/QuoteForm';
import FloatingWhatsApp from './home/components/FloatingWhatsApp';

import FloatingAI from './home/components/FloatingAI';
import FAQSection from './home/components/FAQSection';
import { handlePhoneClick } from '../utils/trackPhoneCall';
import { siteConfig } from '../config/site';
import PageMeta from '../components/PageMeta';
import { climatizacaoServices } from '../data/climatizacaoServices';
import { zonasPorSlug } from '../data/zonas';
import { climatizacaoServicesList } from '../data/climatizacaoServices';
import { limpezaServices } from '../data/limpezaServices';

// serviceId permite montar esta página em rotas com URL próprio
// (ex.: /manutencao-ar-condicionado) além do padrão /servico/:id
const Servico = ({ serviceId, zonaSlug }: { serviceId?: string; zonaSlug?: string } = {}) => {
  const { id: paramId } = useParams<{ id: string }>();
  const id = serviceId || paramId;
  const isDesentupimentosSite = siteConfig.domain === 'alphadesentupimentos.pt';
  const isEletricaSite = siteConfig.domain === 'alphaeletrica.pt' || siteConfig.domain === 'alphaeletric.pt';
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';
  const isCleanSite = siteConfig.domain === 'alphaclean.pt';
  const cityName = siteConfig.address.city;

  // Serviços para o site alphadesentupimentos.pt
  const desentupimentosServices: Record<string, {
    title: string;
    subtitle: string;
    description: string;
    image: string;
    features: string[];
    fullContent?: string;
  }> = {
    'esgotos': {
      title: 'Desentupimento de Esgotos em Lisboa',
      subtitle: 'Serviço profissional para habitações, condomínios e empresas',
      description: 'A Alpha Desentupimentos é especialista em desentupimento de esgotos em Lisboa, atuando de forma rápida e eficaz em habitações, condomínios, empresas e estabelecimentos comerciais.',
      image: '/images/desentupimento-esgoto-real.webp',
      imagePosition: 'center 30%',
      features: [],
      fullContent: `A Alpha Desentupimentos é especialista em desentupimento de esgotos em Lisboa, atuando de forma rápida e eficaz em habitações, condomínios, empresas e estabelecimentos comerciais. Os entupimentos na rede de esgotos podem causar retornos de água, maus odores, infiltrações e danos estruturais, por isso exigem intervenção profissional imediata.

Realizamos o desentupimento de esgotos domésticos e prediais, incluindo ramais, colunas, caixas de inspeção e redes internas, utilizando equipamentos modernos e técnicas adequadas para cada situação. Atuamos em entupimentos causados por gordura acumulada, resíduos sólidos, papel, raízes, calcário e outros detritos comuns nas tubagens.

O nosso serviço de desentupimento de esgotos em Lisboa é feito sem recurso a obras sempre que possível, garantindo uma solução eficaz, limpa e segura. Antes de qualquer intervenção, avaliamos a situação para aplicar o método mais indicado, evitando danos na canalização.

Disponibilizamos desentupimentos de esgotos 24 horas, incluindo noites, fins de semana e feriados, com resposta rápida em toda a zona de Lisboa. Se o seu esgoto entupiu, a Alpha Desentupimentos resolve com profissionalismo, transparência e rapidez.`
    },
    'sanitas': {
      title: 'Desentupimento de Sanitas em Lisboa',
      subtitle: 'Serviço profissional para resolver situações urgentes',
      description: 'A Alpha Desentupimentos presta um serviço profissional de desentupimento de sanitas em Lisboa, com intervenção rápida e eficaz para resolver situações urgentes.',
      image: '/images/desentupimento-sanitas-real.webp',
      imagePosition: 'center 30%',
      features: [],
      fullContent: `A Alpha Desentupimentos presta um serviço profissional de desentupimento de sanitas em Lisboa, com intervenção rápida e eficaz para resolver situações urgentes em casas, apartamentos, condomínios, restaurantes e espaços comerciais. Uma sanita entupida é um problema sério que provoca maus odores, risco de transbordo e torna o espaço inutilizável.

Os entupimentos em sanitas são geralmente causados por excesso de papel higiénico, objetos estranhos, toalhitas, resíduos sólidos ou problemas na canalização. A nossa equipa utiliza equipamentos adequados que permitem remover a obstrução sem danificar a loiça sanitária nem a tubagem.

O serviço de desentupimento de sanitas em Lisboa é realizado de forma limpa e segura, evitando improvisos que podem agravar o problema. Avaliamos a causa do entupimento e aplicamos a técnica correta para garantir que o problema não volte a ocorrer.

Atendemos 24 horas por dia, incluindo fins de semana e feriados, com deslocação rápida em toda a área de Lisboa. Sempre que a sanita entope, a Alpha Desentupimentos está pronta para resolver com profissionalismo e rapidez.`
    },
    'lavatorios-pias': {
      title: 'Desentupimento de Lavatórios e Pias em Lisboa',
      subtitle: 'Resolvendo problemas comuns em cozinhas e casas de banho',
      description: 'A Alpha Desentupimentos é especialista em desentupimento de lavatórios e pias em Lisboa, resolvendo problemas comuns em cozinhas e casas de banho de forma rápida e eficaz.',
      image: '/images/desentupimento-pias-real.webp',
      imagePosition: 'center 30%',
      features: [],
      fullContent: `A Alpha Desentupimentos é especialista em desentupimento de lavatórios e pias em Lisboa, resolvendo problemas comuns em cozinhas e casas de banho de forma rápida e eficaz. Quando a água demora a escoar ou começa a voltar, é sinal claro de obstrução nas tubagens, que deve ser tratada por profissionais.

Os entupimentos em pias e lavatórios são normalmente causados por acumulação de gordura, restos de comida, detergentes, sabonetes, cabelos e resíduos sólidos que se acumulam ao longo do tempo. Utilizamos equipamentos profissionais que removem a obstrução sem danificar a canalização.

O nosso serviço de desentupimento de pias e lavatórios em Lisboa é realizado de forma limpa, segura e sem necessidade de obras. Avaliamos a origem do problema e aplicamos a técnica mais adequada para garantir um escoamento correto e duradouro.

Disponibilizamos atendimento 24 horas por dia, incluindo noites, fins de semana e feriados, com resposta rápida em toda a zona de Lisboa. Se a sua pia ou lavatório entupiu, a Alpha Desentupimentos resolve com eficiência e profissionalismo.`
    },
    'colunas-prediais': {
      title: 'Desentupimento de Colunas Prediais em Lisboa',
      subtitle: 'Prestando apoio técnico a condomínios e prédios',
      description: 'A Alpha Desentupimentos é especializada em desentupimento de colunas prediais em Lisboa, prestando apoio técnico a condomínios, administradores, prédios residenciais e edifícios comerciais.',
      image: '/images/desentupimento-torre-real.webp',
      features: [],
      fullContent: `A Alpha Desentupimentos é especializada em desentupimento de colunas prediais em Lisboa, prestando apoio técnico a condomínios, administradores, prédios residenciais e edifícios comerciais. Os entupimentos nas colunas de esgoto são problemas graves, pois afetam vários apartamentos em simultâneo e podem causar retornos de água, infiltrações e maus odores.

As colunas prediais acumulam, ao longo do tempo, gordura, resíduos sólidos, papel, calcário e outros detritos que comprometem o escoamento. A nossa equipa atua com equipamentos profissionais adequados para desobstruir a coluna de forma eficaz, minimizando transtornos para os moradores.

O serviço de desentupimento de colunas de esgoto em Lisboa é realizado com diagnóstico técnico prévio, garantindo a aplicação da solução correta sem danificar a estrutura do edifício. Sempre que necessário, utilizamos técnicas avançadas para limpeza profunda da tubagem.

Disponibilizamos atendimento 24 horas por dia, incluindo fins de semana e feriados, com resposta rápida em toda a área de Lisboa. A Alpha Desentupimentos garante um serviço profissional, rápido e seguro para resolver entupimentos em colunas prediais.`
    },
    'hidrojato': {
      title: 'Desentupimento com Hidrojato em Lisboa',
      subtitle: 'Indicado para obstruções difíceis e entupimentos recorrentes',
      description: 'A Alpha Desentupimentos oferece serviço profissional de desentupimento com hidrojato em Lisboa, indicado para obstruções difíceis e entupimentos recorrentes nas tubagens.',
      image: '/images/desentupimento-hidrojato-real.webp',
      imagePosition: 'center 30%',
      features: [],
      fullContent: `A Alpha Desentupimentos oferece serviço profissional de desentupimento com hidrojato em Lisboa, indicado para obstruções difíceis e entupimentos recorrentes nas tubagens. O hidrojato utiliza jato de água de alta pressão para remover gordura solidificada, incrustações, resíduos acumulados e detritos aderidos às paredes internas dos canos.

Este método é altamente eficaz em redes de esgoto domésticas, prediais e comerciais, permitindo uma limpeza profunda da tubagem sem necessidade de obras ou desmontagens. O desentupimento com hidrojato em Lisboa garante não apenas a remoção da obstrução, mas também a prevenção de novos entupimentos a curto prazo.

A nossa equipa avalia previamente o tipo de tubagem e o grau de obstrução, aplicando a pressão adequada para garantir segurança e eficiência. O serviço é realizado de forma limpa, rápida e sem danos à canalização.

Disponibilizamos hidrojato 24 horas em Lisboa, incluindo atendimento de emergência em fins de semana e feriados. Quando os métodos tradicionais não resolvem, a Alpha Desentupimentos utiliza o hidrojato para restabelecer o funcionamento total da sua rede de esgoto.`
    },
    'video-inspecao': {
      title: 'Vídeo Inspeção de Tubulações em Lisboa',
      subtitle: 'Diagnóstico preciso sem necessidade de obras',
      description: 'A vídeo inspeção de tubulações é uma das formas mais eficazes e precisas de diagnosticar problemas na rede de esgoto sem necessidade de obras.',
      image: '/images/video-inspecao-real.webp',
      features: [],
      fullContent: `As tubagens e redes de esgoto são sistemas delicados e complexos, sobretudo porque, após a construção, a maioria dos canos fica oculta em paredes, pavimentos ou no subsolo. Por esse motivo, identificar a origem de um problema sem causar danos pode ser difícil quando não se utilizam os métodos corretos.

A vídeo inspeção de tubulações é uma das formas mais eficazes e precisas de diagnosticar problemas na rede de esgoto sem necessidade de obras. A Alpha Desentupimentos disponibiliza este serviço em Lisboa, utilizando equipamentos modernos e técnicos especializados para garantir um diagnóstico rigoroso.

**Como funciona a vídeo inspeção de tubulações**

O processo inicia-se, sempre que necessário, com a limpeza interna da tubagem através de hidrojato. De seguida, é introduzida uma câmara de alta definição acoplada a um cabo flexível, que percorre o interior da tubulação. As imagens são transmitidas em tempo real para um monitor, permitindo visualizar com precisão o estado interno dos canos.

Este método permite identificar entupimentos, fissuras, deslocamentos, infiltração de raízes, desgaste da tubagem ou outros defeitos estruturais, tudo sem partir paredes ou pavimentos.

**Vantagens da vídeo inspeção de esgotos**

A principal vantagem da vídeo inspeção de tubulações em Lisboa é ser um método totalmente não invasivo. Evita o tradicional "quebra-quebra", reduz custos com obras, elimina desperdícios e garante maior rapidez na resolução do problema.

Outro benefício é a precisão do diagnóstico. Com imagens nítidas, o problema é identificado exatamente no ponto certo, permitindo uma reparação mais rápida, segura e económica. Este serviço é especialmente importante em prédios e condomínios, onde as redes horizontais e verticais são mais complexas.`
    }
  };

  // Serviços originais para o site alphacanalizacoes.pt
  const canalizacoesServices: Record<string, {
    title: string;
    subtitle: string;
    description: string;
    image: string;
    features: string[];
  }> = {
    fugas: {
      title: 'Detecção e Reparação de Fugas de Água',
      subtitle: 'Detecção de fugas com equipamento profissional - Reparação urgente',
      description: `Detetamos e reparamos fugas de água com equipamento profissional de última geração. Utilizamos tecnologia avançada para localizar fugas ocultas em paredes, pavimentos e canos sem necessidade de quebrar tudo. Serviço de detecção não invasiva, reparação rápida e eficiente, técnicos especializados em ${cityName}, diagnóstico preciso, garantia no serviço e preço transparente. Se procura "detecção de fugas ${cityName}", "reparar fugas de água" ou "canalizador para fugas", fale connosco e resolvemos rapidamente.`,
      image: '/images/fuga-detecao.webp',
      features: [
        'Detecção não invasiva',
        'Tecnologia avançada',
        'Localização de fugas ocultas',
        'Reparação rápida',
        'Diagnóstico preciso',
        'Sem necessidade de quebrar',
        'Garantia no serviço',
        'Equipamentos certificados',
        'Relatórios técnicos detalhados',
        'Atendimento 24h'
      ]
    },
    reparacao: {
      title: 'Reparação de Canalização',
      subtitle: 'Canos partidos, torneiras avariadas? Reparação urgente 24h',
      description: `Reparamos canos partidos, torneiras avariadas, autoclismos com problemas e toda a canalização doméstica e comercial. Atendimento rápido com técnicos locais em ${cityName}, diagnóstico no local, peças compatíveis de alta qualidade, garantia em serviço e preço transparente. Se procura "reparação canalização urgente ${cityName}" ou "canalizador para reparações", fale connosco e resolvemos rapidamente.`,
      image: '/images/reparacao.webp',
      features: [
        'Reparação de canos',
        'Reparação de torneiras',
        'Reparação de autoclismos',
        'Peças de alta qualidade',
        'Diagnóstico no local',
        'Atendimento 24h',
        'Garantia em serviço'
      ]
    },
    instalacao: {
      title: 'Instalação de Canalização',
      subtitle: 'Instalação nova com garantia e acabamento profissional',
      description: `Instalamos canalização nova para casas, apartamentos e estabelecimentos comerciais. Fazemos instalação de canos, torneiras, autoclismos, máquinas de lavar, esquentadores e toda a infraestrutura hidráulica. Equipa própria, materiais de qualidade, acabamento profissional, garantia em todos os serviços e preço claro. Se procura "instalação canalização ${cityName}" ou "canalizador para obra nova", estamos prontos para ajudar.`,
      image: '/images/instalacao.webp',
      features: [
        'Instalação de canos',
        'Instalação de torneiras',
        'Instalação de autoclismos',
        'Instalação de máquinas de lavar',
        'Instalação de esquentadores',
        'Infraestrutura hidráulica completa',
        'Acabamento profissional',
        'Garantia em todos os serviços'
      ]
    },
    manutencao: {
      title: 'Manutenção Preventiva',
      subtitle: 'Evite problemas com manutenção programada',
      description: `Prolongue a vida útil da sua canalização com um plano de manutenção preventiva: inspeção de canos, verificação de pressão, limpeza de sifões, verificação de fugas e teste de equipamentos. Reduz avarias inesperadas, evita custos elevados e melhora o desempenho. Serviço indicado para casas, condomínios e estabelecimentos comerciais em ${cityName}. Procura "manutenção canalização" ou "inspeção de canos"? Conte com a nossa equipa e receba relatório do estado após cada visita.`,
      image: '/images/manutencao-preventiva-real.webp',
      features: [
        'Inspeção de canos',
        'Verificação de pressão',
        'Limpeza de sifões',
        'Verificação de fugas',
        'Teste de equipamentos',
        'Relatório do estado',
        'Plano de manutenção'
      ]
    },
    remodelacao: {
      title: 'Remodelação de Casas de Banho',
      subtitle: 'Remodelação completa com design moderno e funcional',
      description: `Especialistas em remodelação completa de casas de banho em ${cityName}. Fazemos renovação total com design moderno, instalação de novos sanitários, chuveiros, banheiras, azulejos, pavimentos e toda a canalização. Planeamento personalizado, materiais de qualidade, acabamento profissional, garantia em todos os serviços e orçamento transparente. Se procura "remodelação casa de banho ${cityName}", "renovação WC" ou "casa de banho moderna", estamos prontos para transformar o seu espaço.`,
      image: '/images/remodelacao.webp',
      features: [
        'Renovação completa',
        'Design moderno',
        'Instalação de sanitários',
        'Instalação de chuveiros',
        'Instalação de banheiras',
        'Azulejos e pavimentos',
        'Canalização completa',
        'Planeamento personalizado'
      ]
    }
  };

  // Serviços para o site alphaeletrica.pt
  const eletricaServices: Record<string, {
    title: string;
    subtitle: string;
    description: string;
    image: string;
    features: string[];
    fullContent?: string;
    subServices?: { title: string; description: string; image: string }[];
    steps?: { icon: string; title: string; description: string }[];
    faqs?: { question: string; answer: string }[];
    testimonials?: { name: string; location: string; rating: number; text: string }[];
    imagePosition?: string;
  }> = {
    'instalacao-eletrica': {
      title: 'Instalações Elétricas em Lisboa',
      subtitle: 'Instalação completa com certificação e garantia',
      description: 'A Alpha Elétrica é especialista em instalações elétricas em Lisboa, oferecendo serviços completos para habitações, escritórios, lojas e estabelecimentos comerciais.',
      image: '/images/instalacao-eletrica-real.webp',
      imagePosition: 'top center',
      features: [
        'Instalação elétrica completa',
        'Quadros elétricos',
        'Tomadas e interruptores',
        'Iluminação interior e exterior',
        'Certificação elétrica',
        'Projeto elétrico',
        'Materiais certificados',
        'Garantia no serviço'
      ],
      fullContent: `A Alpha Elétrica é especialista em instalações elétricas em Lisboa, oferecendo serviços completos para habitações, escritórios, lojas e estabelecimentos comerciais. Realizamos instalações elétricas novas e remodelações, sempre com materiais certificados e de acordo com as normas de segurança.

Executamos todo o tipo de instalações elétricas: quadros elétricos, tomadas, interruptores, iluminação interior e exterior, sistemas de aquecimento, portões automáticos e muito mais. A nossa equipa de eletricistas certificados garante um trabalho profissional, seguro e com acabamento de qualidade.

Todos os nossos serviços incluem certificação elétrica obrigatória, projeto elétrico quando necessário e garantia no serviço executado. Trabalhamos com as melhores marcas do mercado e cumprimos rigorosamente todas as normas técnicas e de segurança.

Disponibilizamos atendimento em toda a zona de Lisboa, com orçamentos gratuitos e transparentes. Se procura "instalação elétrica Lisboa" ou "eletricista certificado", a Alpha Elétrica é a escolha certa.`
    },
    'reparacao-eletrica': {
      title: 'Reparação Elétrica Lisboa | Diagnóstico Rápido e Serviço Seguro',
      subtitle: 'Diagnóstico Rápido e Serviço Seguro em Lisboa',
      description: 'Prestamos reparação elétrica em Lisboa com intervenção rápida e segura, ideal para resolver falhas de energia, quedas de disjuntores, tomadas com mau contacto e problemas de iluminação.',
      image: '/images/reparacao-eletrica.webp',
      features: [
        'Diagnóstico com testes de continuidade',
        'Substituição de disjuntores',
        'Correção de ligações soltas',
        'Reparação de circuitos',
        'Relatório técnico',
        'Materiais de qualidade',
        'Garantia no serviço',
        'Intervenção rápida'
      ],
      fullContent: `Prestamos reparação elétrica em Lisboa com intervenção rápida e segura, ideal para resolver falhas de energia, quedas de disjuntores, tomadas com mau contacto e problemas de iluminação. Atuamos em habitações, lojas e escritórios, sempre com foco na segurança dos utilizadores e na conformidade com as normas em vigor.

Quando chamar a reparação elétrica?
Alguns sinais indicam a necessidade de assistência imediata: cheiro a queimado, aquecimento de tomadas, faíscas, disparo frequente do disjuntor ou luzes a oscilar. Nestas situações, o ideal é desligar o circuito afetado e solicitar uma avaliação técnica para evitar danos maiores.

Atuação em toda a região de Lisboa
Chegamos rapidamente a qualquer zona de Lisboa e arredores, minimizando o tempo de inatividade de sua casa ou negócio. Trabalhamos com materiais de qualidade e boas práticas para garantir reparos duradouros e seguros.

Se procura um Eletricista em Lisboa com experiência em reparação elétrica, conte connosco para resolver o problema com transparência e eficiência.`,
      steps: [
        {
          icon: 'ri-search-eye-line',
          title: 'Avaliação no local',
          description: 'Identificamos a causa raiz da falha com equipamento de diagnóstico'
        },
        {
          icon: 'ri-file-list-3-line',
          title: 'Orçamento claro',
          description: 'Explicamos as opções disponíveis e o prazo estimado para a reparação'
        },
        {
          icon: 'ri-tools-fill',
          title: 'Reparação técnica',
          description: 'Solução segura, duradoura e totalmente conforme as normas em vigor'
        },
        {
          icon: 'ri-checkbox-circle-line',
          title: 'Testes finais',
          description: 'Verificação rigorosa de segurança e funcionamento antes de terminar'
        }
      ],
      faqs: [
        {
          question: 'Quanto custa uma reparação elétrica em Lisboa?',
          answer: 'O valor varia conforme a complexidade e as peças necessárias. Apresentamos sempre um orçamento claro antes de avançar com qualquer trabalho.'
        },
        {
          question: 'É possível reparar no mesmo dia?',
          answer: 'Na maioria dos casos, sim. Mantemos peças comuns em stock nas nossas carrinhas para garantir uma intervenção rápida e eficaz.'
        },
        {
          question: 'Oferecem garantia?',
          answer: 'Sim, fornecemos garantia sobre a mão de obra e os materiais aplicados, assegurando a sua tranquilidade.'
        }
      ],
      testimonials: [
        {
          name: 'Jeremy Da Costa',
          location: 'Lisboa',
          rating: 5,
          text: 'Serviço excelente! Todo o trabalho de eletricidade foi realizado rapidamente e os preços são competitivos.'
        },
        {
          name: 'Helita Barroso',
          location: 'Lisboa',
          rating: 5,
          text: 'Serviço impecável! Atendimento rápido, atento e com muita qualidade. Fiquei super satisfeita e recomendo a 100%!'
        },
        {
          name: 'André Luiz',
          location: 'Cascais',
          rating: 5,
          text: 'Amazing service!!!! 👏'
        },
        {
          name: 'Marina de Paula',
          location: 'Lisboa',
          rating: 5,
          text: 'Fiquei super satisfeita com o atendimento. Foram rápidos, profissionais e resolveram tudo com muito cuidado.'
        }
      ]
    },
    'quadro-eletrico': {
      title: 'Quadros Elétricos em Lisboa',
      subtitle: 'Instalação e manutenção de quadros elétricos',
      description: 'Instalamos e fazemos manutenção de quadros elétricos residenciais, comerciais e industriais, com certificação e garantia.',
      image: '/images/quadro-eletrico.webp',
      features: [
        'Instalação de quadros novos',
        'Atualização de quadros antigos',
        'Disjuntores e proteções',
        'Diferenciais',
        'Organização de circuitos',
        'Certificação obrigatória',
        'Manutenção preventiva'
      ],
      fullContent: `A Alpha Elétrica é especialista em instalação e manutenção de quadros elétricos em Lisboa, oferecendo serviços para habitações, condomínios, escritórios, lojas e estabelecimentos industriais.

Instalamos quadros elétricos novos com todos os componentes de segurança obrigatórios: disjuntores, diferenciais, proteções contra sobretensões e organização adequada de circuitos. Também fazemos atualização de quadros elétricos antigos que não cumprem as normas atuais de segurança.

Um quadro elétrico bem dimensionado e organizado é fundamental para a segurança da instalação elétrica. Evita sobrecargas, curto-circuitos e riscos de incêndio. A nossa equipa de eletricistas certificados garante uma instalação profissional, com certificação elétrica obrigatória e garantia no serviço.

Disponibilizamos também serviços de manutenção preventiva de quadros elétricos, com inspeção de componentes, aperto de ligações e verificação de proteções. Se procura "quadro elétrico Lisboa" ou "eletricista para quadros", conte com a Alpha Elétrica.`
    },
    'iluminacao': {
      title: 'Iluminação LED em Lisboa',
      subtitle: 'Instalação de iluminação LED eficiente e económica',
      description: 'Instalamos sistemas de iluminação LED para casas, escritórios e estabelecimentos comerciais, com economia de energia até 80%.',
      image: '/images/iluminacao-led.webp',
      features: [
        'Iluminação LED interior',
        'Iluminação LED exterior',
        'Focos embutidos',
        'Fitas LED',
        'Iluminação decorativa',
        'Economia até 80%',
        'Projeto de iluminação'
      ],
      fullContent: `A Alpha Elétrica é especialista em instalação de iluminação LED em Lisboa, oferecendo soluções eficientes e económicas para habitações, escritórios, lojas e estabelecimentos comerciais.

A iluminação LED permite uma poupança de energia até 80% comparada com lâmpadas tradicionais, tem maior durabilidade e oferece melhor qualidade de luz. Instalamos todo o tipo de iluminação LED: focos embutidos, painéis LED, fitas LED, projetores LED, candeeiros LED e iluminação decorativa.

Fazemos projetos de iluminação personalizados, adequados às necessidades de cada espaço. A nossa equipa de eletricistas certificados garante uma instalação profissional, com acabamento de qualidade e garantia no serviço executado.

Disponibilizamos atendimento em toda a zona de Lisboa, com orçamentos gratuitos e transparentes. Se procura "iluminação LED Lisboa" ou "instalação de LED", a Alpha Elétrica é a escolha certa para modernizar a sua iluminação com eficiência e economia.`
    },
    'certificacao': {
      title: 'Certificação Elétrica em Lisboa',
      subtitle: 'Certificado elétrico obrigatório para habitações e comércios',
      description: 'Emitimos certificados elétricos obrigatórios para habitações, estabelecimentos comerciais e industriais, de acordo com as normas em vigor.',
      image: '/images/certificacao-eletrica.webp',
      features: [
        'Certificado elétrico',
        'Inspeção completa',
        'Relatório técnico',
        'Correção de anomalias',
        'Eletricista certificado',
        'Entrega rápida',
        'Preço transparente'
      ],
      fullContent: `A Alpha Elétrica emite certificados elétricos obrigatórios em Lisboa, para habitações, estabelecimentos comerciais e industriais, de acordo com as normas técnicas em vigor.

O certificado elétrico é obrigatório para venda, arrendamento, alteração de potência contratada e novas instalações. A nossa equipa de eletricistas certificados realiza uma inspeção completa da instalação elétrica, identifica eventuais anomalias e emite o relatório técnico e certificado elétrico.

Caso sejam detetadas anomalias durante a inspeção, executamos as correções necessárias para garantir que a instalação cumpre todas as normas de segurança. Todos os serviços incluem garantia e são executados por profissionais certificados.

Disponibilizamos atendimento em toda a zona de Lisboa, com orçamentos gratuitos e prazos de entrega rápidos. Se precisa de "certificado elétrico Lisboa" ou "certificação elétrica", a Alpha Elétrica resolve com profissionalismo e rapidez.`
    },
    'inspecoes': {
      title: 'Inspeções Elétricas em Lisboa',
      subtitle: 'Inspeção completa da instalação elétrica',
      description: 'Realizamos inspeções elétricas completas para identificar problemas, riscos e anomalias na instalação elétrica.',
      image: '/images/inspecao-eletrica.webp',
      features: [
        'Inspeção visual',
        'Testes de segurança',
        'Medição de resistências',
        'Verificação de proteções',
        'Relatório detalhado',
        'Recomendações técnicas',
        'Orçamento para correções'
      ],
      fullContent: `A Alpha Elétrica realiza inspeções elétricas completas em Lisboa, para habitações, condomínios, escritórios e estabelecimentos comerciais, identificando problemas, riscos e anomalias na instalação elétrica.

A inspeção elétrica inclui verificação visual de todos os componentes, testes de segurança, medição de resistências de terra, verificação de proteções (disjuntores e diferenciais), análise do quadro elétrico e identificação de sobrecargas ou instalações inadequadas.

Após a inspeção, entregamos um relatório técnico detalhado com todas as anomalias encontradas, recomendações técnicas e orçamento para as correções necessárias. Este serviço é fundamental para garantir a segurança da instalação elétrica e prevenir acidentes.

Disponibilizamos atendimento em toda a zona de Lisboa, com eletricistas certificados e equipamentos de diagnóstico profissionais. Se procura "inspeção elétrica Lisboa" ou "verificação de instalação elétrica", conte com a Alpha Elétrica.`
    },
    'detecao-avarias': {
      title: 'Deteção de Avarias Elétricas em Lisboa',
      subtitle: 'Diagnóstico preciso com equipamento profissional',
      description: 'Utilizamos equipamento profissional para detetar avarias elétricas ocultas, curto-circuitos e problemas de isolamento.',
      image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=1200&h=800&fit=crop',
      features: [
        'Deteção de curto-circuitos',
        'Localização de avarias ocultas',
        'Testes de isolamento',
        'Termografia',
        'Equipamento profissional',
        'Diagnóstico preciso',
        'Reparação imediata'
      ],
      fullContent: `A Alpha Elétrica utiliza equipamento profissional para deteção de avarias elétricas em Lisboa, identificando problemas ocultos, curto-circuitos, falhas de isolamento e outros defeitos na instalação elétrica.

Utilizamos equipamentos de diagnóstico avançados, incluindo multímetros profissionais, medidores de isolamento, detetores de cabos e termografia, que permitem localizar avarias com precisão sem necessidade de partir paredes ou pavimentos.

A deteção precisa da avaria permite uma reparação mais rápida, económica e eficaz. A nossa equipa de eletricistas certificados identifica a origem do problema e executa a reparação de forma segura, com materiais certificados e garantia no serviço.

Disponibilizamos atendimento urgente 24 horas em toda a zona de Lisboa, incluindo fins de semana e feriados. Se tem uma avaria elétrica difícil de localizar, a Alpha Elétrica resolve com tecnologia e profissionalismo.`
    },
    'manutencao': {
      title: 'Manutenção Elétrica Preventiva em Lisboa',
      subtitle: 'Evite avarias com manutenção programada',
      description: 'Prolongue a vida útil da sua instalação elétrica e evite avarias inesperadas com um plano de manutenção preventiva.',
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200&h=800&fit=crop',
      features: [
        'Inspeção periódica',
        'Aperto de ligações',
        'Verificação de proteções',
        'Limpeza de quadros',
        'Testes de segurança',
        'Relatório do estado',
        'Plano de manutenção'
      ],
      fullContent: `A Alpha Elétrica oferece serviços de manutenção elétrica preventiva em Lisboa, para habitações, condomínios, escritórios e estabelecimentos comerciais, prolongando a vida útil da instalação elétrica e evitando avarias inesperadas.

A manutenção preventiva inclui inspeção periódica de todos os componentes, aperto de ligações, verificação e teste de proteções (disjuntores e diferenciais), limpeza de quadros elétricos, verificação de tomadas e interruptores, e testes de segurança.

Um plano de manutenção preventiva reduz significativamente o risco de avarias, melhora a segurança da instalação, aumenta a eficiência energética e evita custos elevados com reparações de emergência. Após cada visita, entregamos um relatório detalhado do estado da instalação.

Disponibilizamos planos de manutenção personalizados para cada tipo de instalação, com periodicidade adequada às necessidades. Se procura "manutenção elétrica Lisboa" ou "inspeção elétrica preventiva", conte com a Alpha Elétrica.`
    },
    'climatizacao-automacao': {
      title: 'Climatização em Lisboa',
      subtitle: 'Conforto térmico para o seu lar',
      description: 'Soluções completas de climatização: ar condicionado e ventilacão de última geração.',
      image: '/images/climatizacao-hero.webp',
      imagePosition: 'center center',
      features: [
        'Instalação de Ar Condicionado',
        'Manutenção de Ar Condicionado',
        'Sistemas de Ventilação',
        'Sistemas de Controlo Remoto',
        'Integração Domótica'
      ],
      fullContent: `A Alpha Elétrica oferece soluções integradas de climatização para modernizar a sua casa em Lisboa. Garantimos o máximo conforto térmico que a sua família merece, com equipamentos de marcas líderes e instalação profissional.`,
      subServices: [
        {
          title: 'Instalação de Ar Condicionado',
          description: 'Instalação profissional de sistemas de ar condicionado residenciais e comerciais. Garantimos um dimensionamento correto e uma instalação limpa e eficiente para o máximo conforto.',
          image: '/images/ar-condicionado-moderno.webp'
        },
        {
          title: 'Manutenção de Ar Condicionado',
          description: 'Serviço completo de manutenção preventiva e corretiva. Limpeza de filtros, verificação de gás, higienização e testes de funcionamento para garantir a longevidade do seu equipamento.',
          image: '/images/manutencao-ac.webp'
        },
        {
          title: 'Sistema AVAC',
          description: 'Soluções integradas de Aquecimento, Ventilação e Ar Condicionado para edifícios e grandes espaços. Projetos, instalação e manutenção de sistemas complexos de climatização.',
          image: '/images/climatizacao-hero.webp'
        }
      ]
    },
    'reparacao-ar-condicionado': {
      title: 'Reparação e Manutenção de Ar Condicionado em Lisboa',
      subtitle: 'Técnicos Certificados | Atendimento Urgente 24h | Todas as Marcas',
      description: 'Serviço especializado de reparação e manutenção de ar condicionado em Lisboa. Diagnóstico rápido, recarga de gás, limpeza de filtros e reparação de avarias em todas as marcas. Eletricistas certificados com atendimento urgente 24h.',
      image: '/images/ar-condicionado-moderno.webp',
      imagePosition: 'center center',
      features: [
        'Reparação de Avarias em Ar Condicionado',
        'Manutenção Preventiva e Corretiva',
        'Recarga de Gás Refrigerante (R32, R410A)',
        'Limpeza e Higienização Profissional',
        'Substituição de Filtros e Componentes',
        'Diagnóstico Eletrónico de Falhas',
        'Reparação de Fugas de Gás',
        'Atendimento Urgente 24h'
      ],
      fullContent: `A Alpha Elétrica é especialista em reparação e manutenção de ar condicionado em Lisboa, oferecendo um serviço técnico completo para equipamentos residenciais e comerciais de todas as marcas: Daikin, Mitsubishi, Samsung, LG, Toshiba, Fujitsu, Haier, Hisense e muitas outras.

Quando o seu ar condicionado deixa de arrefecer, faz ruídos estranhos, apresenta fugas de água, mau cheiro ou simplesmente não liga, é essencial contactar um técnico qualificado para evitar danos maiores no equipamento. A nossa equipa de eletricistas certificados realiza o diagnóstico completo do sistema e repara a avaria de forma rápida, segura e com garantia no serviço.

Tipos de Avarias que Reparamos:
• Ar condicionado não arrefece ou não aquece
• Unidade interior ou exterior não liga
• Fugas de água na unidade interior
• Ruídos anormais (vibrações, estalos, zumbidos)
• Mau cheiro ao ligar o equipamento
• Erro no display ou códigos de erro
• Fuga de gás refrigerante
• Problemas no compressor ou ventilador
• Avaria na placa eletrónica
• Controlo remoto não funciona

Manutenção Preventiva — Por que é Essencial?
A manutenção regular do ar condicionado é fundamental para garantir o bom funcionamento, a eficiência energética e a qualidade do ar interior. Um equipamento sem manutenção consome até 30% mais energia, tem maior probabilidade de avariar e pode acumular bactérias, fungos e ácaros que prejudicam a saúde.

A manutenção preventiva da Alpha Elétrica inclui:
• Limpeza profunda dos filtros de ar
• Higienização da unidade interior com produto bactericida
• Verificação e recarga de gás refrigerante (se necessário)
• Inspeção do sistema elétrico e ligações
• Limpeza da unidade exterior (condensador)
• Verificação do dreno e tubagem de condensação
• Teste completo de funcionamento e temperatura
• Relatório técnico detalhado

Trabalhamos com Todas as Marcas:
Daikin, Mitsubishi Electric, Samsung, LG, Toshiba, Fujitsu, Haier, Hisense, Carrier, General, Panasonic, Bosch e outras. Dispomos de peças de reposição originais e alternativas de qualidade para a maioria dos modelos.

Serviço Urgente 24 Horas:
Sabemos que uma avaria no ar condicionado durante o verão pode ser extremamente desconfortável. Por isso, disponibilizamos atendimento urgente 24 horas, 7 dias por semana, incluindo fins de semana e feriados. A nossa equipa desloca-se rapidamente a qualquer zona de Lisboa e arredores.

Se procura "reparação de ar condicionado Lisboa", "manutenção de ar condicionado" ou "técnico de ar condicionado urgente", contacte a Alpha Elétrica para um diagnóstico rápido e orçamento gratuito.`,
      subServices: [
        {
          title: 'Reparação de Avarias',
          description: 'Diagnóstico eletrónico avançado e reparação de todos os tipos de avarias: problemas no compressor, placas eletrónicas, ventiladores, sensores e fugas de gás. Serviço rápido com garantia.',
          image: '/images/ar-condicionado-moderno.webp'
        },
        {
          title: 'Manutenção Preventiva',
          description: 'Limpeza completa de filtros, higienização bactericida, verificação de gás refrigerante, inspeção elétrica e teste de funcionamento. Previna avarias e poupe até 30% na conta de energia.',
          image: '/images/manutencao-ac.webp'
        },
        {
          title: 'Recarga de Gás Refrigerante',
          description: 'Recarga profissional de gás R32, R410A e R22 com deteção e reparação de fugas. Verificação de pressão e teste de temperatura para garantir o máximo rendimento do seu equipamento.',
          image: '/images/climatizacao-hero.webp'
        },
        {
          title: 'Limpeza e Higienização',
          description: 'Higienização profunda da unidade interior e exterior com produtos específicos anti-bactérias e anti-fungos. Elimine maus odores e garanta um ar limpo e saudável para a sua família.',
          image: '/images/climatizacao-hero.webp'
        }
      ],
      steps: [
        { icon: 'ri-phone-line', title: '1. Contacte-nos', description: 'Ligue ou envie mensagem a descrever o problema com o seu ar condicionado.' },
        { icon: 'ri-search-line', title: '2. Diagnóstico', description: 'O nosso técnico desloca-se ao local e realiza um diagnóstico completo do equipamento.' },
        { icon: 'ri-tools-line', title: '3. Reparação', description: 'Reparamos a avaria no local, sempre que possível, com peças originais e garantia.' },
        { icon: 'ri-check-double-line', title: '4. Teste e Garantia', description: 'Testamos o equipamento, entregamos relatório técnico e garantia escrita do serviço.' }
      ],
      faqs: [
        {
          question: 'Quanto custa a reparação de um ar condicionado?',
          answer: 'O custo depende do tipo de avaria. Oferecemos orçamento gratuito após o diagnóstico. A deslocação e o diagnóstico têm um valor fixo que é deduzido caso aprove a reparação.'
        },
        {
          question: 'Com que frequência devo fazer manutenção no ar condicionado?',
          answer: 'Recomendamos uma manutenção preventiva pelo menos 1 vez por ano, idealmente antes do verão. Em ambientes com uso intensivo (escritórios, restaurantes), recomendamos 2 vezes por ano.'
        },
        {
          question: 'O meu ar condicionado não arrefece. O que pode ser?',
          answer: 'As causas mais comuns são: filtros sujos, falta de gás refrigerante, problemas no compressor ou avaria na placa eletrónica. Um diagnóstico profissional é essencial para identificar a causa exata.'
        },
        {
          question: 'Reparam todas as marcas de ar condicionado?',
          answer: 'Sim, reparamos todas as marcas: Daikin, Mitsubishi, Samsung, LG, Toshiba, Fujitsu, Haier, Hisense, Carrier, Panasonic, Bosch e outras.'
        },
        {
          question: 'O ar condicionado deita água. É normal?',
          answer: 'Não é normal. Geralmente indica um problema no dreno de condensação (entupido ou desligado), bandeja de condensação cheia ou filtros obstruídos. Contacte-nos para resolver rapidamente.'
        },
        {
          question: 'Fazem atendimento ao fim de semana e feriados?',
          answer: 'Sim, disponibilizamos atendimento urgente 24h, 7 dias por semana, incluindo fins de semana e feriados em toda a zona de Lisboa.'
        }
      ]
    },
    'seguranca': {
      title: 'Segurança Eletrónica e Controlo de Acessos',
      subtitle: 'Proteção inteligente para a sua casa e empresa',
      description: 'Soluções avançadas de segurança: vídeo porteiros, fechaduras eletrónicas, automação de portões e controlo de acessos.',
      image: '/images/video-porteiro.webp',
      imagePosition: 'center center',
      features: [
        'Vídeo Porteiros Inteligentes',
        'Fechaduras Eletrónicas',
        'Controlo de Acessos',
        'Portões Automáticos',
        'Manutenção de Sistemas'
      ],
      fullContent: `A Alpha Elétrica oferece as mais modernas soluções de segurança eletrónica para proteger o que é mais importante para si. Integramos tecnologia e segurança para um controlo total do seu espaço.`,
      subServices: [
        {
          title: 'Vídeo Porteiros e Controlo de Acessos',
          description: 'Instalação de sistemas de vídeo porteiro de última geração com ligação ao telemóvel, permitindo ver e falar com quem toca à campainha de qualquer lugar.',
          image: '/images/video-porteiro.webp'
        },
        {
          title: 'Portões Automáticos e Barreiras',
          description: 'Automação de portões de garagem, portões de correr e barreiras de acesso. Instalação de motores seguros e fiáveis com comando à distância e integração domótica.',
          image: '/images/portao-automatico.webp'
        },
        {
          title: 'Fechaduras Inteligentes',
          description: 'Fechaduras eletrónicas e biométricas para maior segurança e conveniência. Abra a porta com código, impressão digital ou smartphone. Ideal para alojamento local e escritórios.',
          image: '/images/fechadura-inteligente.webp'
        },
        {
          title: 'Manutenção de Sistemas de Segurança',
          description: 'Serviço técnico especializado para manutenção e reparação de sistemas de segurança, portões e vídeo porteiros, garantindo o funcionamento contínuo da sua proteção.',
          image: '/images/inspecao-eletrica.webp'
        }
      ]
    },
    'exterior-mobilidade': {
      title: 'Exterior e Mobilidade Elétrica',
      subtitle: 'Soluções inteligentes para garagem e jardim',
      description: 'Prepare a sua casa para o futuro com carregadores de veículos elétricos, portões automáticos e iluminação de jardim.',
      image: '/images/exterior-hero.webp',
      imagePosition: 'center center',
      features: [
        'Instalação de Wallbox',
        'Carregadores de Carros Elétricos',
        'Automatismo de Portões',
        'Motores para Portões de Correr/Batente',
        'Iluminação de Jardim',
        'Sistemas de Rega Automática',
        'Sensores de Movimento Exterior'
      ],
      fullContent: `A Alpha Elétrica transforma o exterior da sua casa num espaço funcional, seguro e preparado para a mobilidade elétrica. Oferecemos soluções completas para garagens, acessos e jardins em Lisboa e arredores.`,
      subServices: [
        {
          title: 'Mobilidade Elétrica (Wallbox)',
          description: 'Instalamos postos de carregamento para veículos elétricos (Wallbox) em garagens particulares e condomínios. Fazemos a avaliação da potência necessária, instalação do quadro de proteção e certificação do carregador, garantindo um carregamento rápido e seguro para o seu automóvel.',
          image: '/images/wallbox-garagem.webp'
        },
        {
          title: 'Portões Automáticos',
          description: 'Automatizamos portões de garagem, de correr ou de batente. A instalação de um motor elétrico no portão traz conforto e segurança, evitando que tenha de sair do carro para abrir a garagem. Realizamos também a manutenção e reparação de automatismos existentes.',
          image: '/images/portao-automatico.webp'
        },
        {
          title: 'Rega e Iluminação de Jardim',
          description: 'Valorize o seu espaço exterior com sistemas de iluminação LED eficientes e rega automática. Criamos ambientes acolhedores para o seu jardim e garantimos a rega adequada das suas plantas com temporizadores e sensores de chuva, poupando água e tempo.',
          image: '/images/sistema-rega.webp'
        }
      ]
    },
    'estores': {
      title: 'Estores e Persianas em Lisboa',
      subtitle: 'Instalação, Motorização e Reparação de Estores',
      description: 'Serviço completo de estores em Lisboa: reparação, instalação de novos e motorização de estores manuais.',
      image: '/images/estores-hero.webp',
      imagePosition: 'center center',
      features: [
        'Reparação de Estores',
        'Instalação de Estores Novos',
        'Motorização de Estores Manuais',
        'Estores Térmicos e Acústicos',
        'Estores de Rolo e Laminados',
        'Substituição de Fitas e Enroladores',
        'Arranjo de Estores Elétricos'
      ],
      fullContent: `A Alpha Elétrica disponibiliza um serviço especializado em estores e persianas em Lisboa. Atuamos na reparação, instalação e motorização de todo o tipo de estores, desde os tradicionais manuais aos mais modernos estores elétricos.
      
      Seja para melhorar o isolamento térmico da sua casa, aumentar a segurança ou simplesmente pelo conforto da motorização, temos a solução ideal para si. Trabalhamos com materiais de alta qualidade (alumínio térmico, PVC) e motores de marcas conceituadas.`,
      subServices: [
        {
          title: 'Reparação de Estores',
          description: 'O seu estore encravou, a fita partiu ou o motor avariou? A nossa equipa de técnicos especializados realiza a reparação de estores manuais e elétricos de forma rápida e eficiente. Substituímos lâminas, fitas, enroladores, batentes e motores avariados.',
          image: '/images/estores-reparacao.webp'
        },
        {
          title: 'Motorização de Estores',
          description: 'Transforme os seus estores manuais em elétricos. A motorização traz maior conforto e valoriza o seu imóvel. Instalamos motores silenciosos e fiáveis, com opção de comando à distância, interruptor de parede ou controlo via smartphone (domótica).',
          image: '/images/motorizacao-estore.webp'
        },
        {
          title: 'Instalação de Estores Novos',
          description: 'Fornecimento e instalação de estores novos por medida. Dispomos de uma vasta gama de opções: estores térmicos em alumínio, estores em PVC, estores de rolo, brisa solar e muito mais. Aconselhamos a melhor solução para as suas necessidades de isolamento e estética.',
          image: '/images/estores-novos.webp'
        }
      ]
    },
    'energia-renovavel': {
      title: 'Energias Renováveis e Eficiência',
      subtitle: 'Produza a sua própria energia e reduza a fatura',
      description: 'Especialistas em eficiência energética: instalação de painéis solares e bombas de calor para o máximo de poupança.',
      image: '/images/energia-hero.webp',
      imagePosition: 'center center',
      features: [
        'Instalação de Painéis Solares',
        'Autoconsumo Fotovoltaico',
        'Bombas de Calor AQS',
        'Baterias de Armazenamento',
        'Inversores Solares',
        'Gestão de Energia',
        'Manutenção de Sistemas Solares'
      ],
      fullContent: `Aposte na sustentabilidade e na poupança com as soluções de energia renovável da Alpha Elétrica. Ajudamos famílias e empresas em Lisboa a reduzir a fatura de eletricidade e a pegada ecológica através de tecnologias eficientes.`,
      subServices: [
        {
          title: 'Bombas de Calor',
          description: 'Substitua o seu esquentador ou caldeira por uma bomba de calor para Águas Quentes Sanitárias (AQS). É a forma mais eficiente de aquecer água, consumindo até 75% menos energia que os sistemas tradicionais, aproveitando o calor do ar ambiente.',
          image: '/images/bomba-calor.webp'
        },
        {
          title: 'Painéis Solares Fotovoltaicos',
          description: 'Produza a sua própria eletricidade com a instalação de painéis solares. Dimensionamos o sistema ideal para o seu consumo, tratamos de todo o processo de instalação e legalização. O autoconsumo permite uma redução drástica na conta de luz e um retorno rápido do investimento. Para além da instalação, oferecemos soluções de armazenamento (baterias).',
          image: '/images/painel-solar.webp'
        }
      ]
    }
  };

  // Escolhe os serviços corretos baseado no site
  const services: Record<string, any> = isCleanSite ? limpezaServices :
    isClimatizacaoSite ? climatizacaoServices :
    isEletricaSite ? eletricaServices :
      isDesentupimentosSite ? desentupimentosServices :
        canalizacoesServices;
  const service = id ? services[id] : null;

  if (!service) {
    return (
      <div className="min-h-screen bg-white">
        <PageMeta
          title="Serviço não encontrado"
          description="A página que procura não existe."
          path={`/servico/${id || ''}`}
          noindex
        />
        <Header />
        <main className="pt-20 text-center py-20">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Serviço não encontrado</h1>
          <Link to="/" className="text-blue-600 hover:text-blue-700">
            Voltar à página inicial
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  // Páginas com blocos escaneáveis (benefícios/categorias) mostram só o primeiro
  // parágrafo no topo e remetem o texto longo para o fim, dentro de um expansor.
  // Os restantes sites mantêm exatamente o comportamento anterior.
  const temBlocosEscaneaveis = Boolean((service as any).beneficios);
  const paragrafos: string[] = (service as any).fullContent
    ? String((service as any).fullContent).split('\n\n').filter(Boolean)
    : [];
  const paragrafoIntro = paragrafos[0];
  const paragrafosRestantes = paragrafos.slice(1);

  const irParaOrcamento = () =>
    document.getElementById('orcamento')?.scrollIntoView({ behavior: 'smooth' });

  // Canonical: nos sites com URL curto por serviço (ex.: /manutencao-ar-condicionado)
  // é esse o endereço oficial; /servico/:id é apenas um alias.
  // Página local (serviço numa zona) ou página de serviço geral
  const zona = zonaSlug ? zonasPorSlug[zonaSlug] : undefined;

  const tituloPagina = zona
    ? `${(service as any).tituloLocal || service.title} ${zona.preposicao} ${zona.nome}`
    : service.title;

  const descricaoPagina = zona
    ? `${(service as any).tituloLocal || service.title} ${zona.preposicao} ${zona.nome}. ${zona.notasPorServico?.[id as string] || service.description}`.slice(0, 300)
    : service.description;

  const canonicalPath = zona
    ? `/${(service as any).slug}-${zona.slug}`
    : (service as any).slug
      ? `/${(service as any).slug}`
      : `/servico/${id}`;

  const jsonLd: Record<string, unknown>[] = [
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: tituloPagina,
      serviceType: (service as any).tituloLocal || service.title,
      description: descricaoPagina,
      url: `https://www.${siteConfig.domain}${canonicalPath}`,
      areaServed: zona
        ? { '@type': zona.tipo === 'concelho' ? 'City' : 'Place', name: zona.nome }
        : { '@type': 'City', name: cityName },
      provider: {
        '@type': 'LocalBusiness',
        name: siteConfig.name,
        telephone: siteConfig.phone,
        email: siteConfig.email,
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteConfig.address.street,
          addressLocality: siteConfig.address.city,
          postalCode: siteConfig.address.postalCode,
          addressCountry: siteConfig.address.country
        }
      }
    }
  ];

  if ((service as any).faqs?.length) {
    jsonLd.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: (service as any).faqs.map((faq: { question: string; answer: string }) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: { '@type': 'Answer', text: faq.answer }
      }))
    });
  }

  return (
    <div className="min-h-screen bg-white" >
      <PageMeta
        title={tituloPagina}
        description={descricaoPagina}
        path={canonicalPath}
        keywords={zona ? `${(service as any).tituloLocal} ${zona.nome}, ar condicionado ${zona.nome}, técnico ar condicionado ${zona.nome}` : undefined}
        jsonLd={jsonLd}
      />
      <Header />

      {/* Hero Section com imagem de capa, headline e subheadline */}
      <section className={`relative flex items-center justify-center overflow-hidden ${temBlocosEscaneaveis
        ? 'h-[55vh] md:h-[60vh] lg:h-[65vh]'
        : 'h-[75vh] md:h-[85vh] lg:h-[95vh]'}`} >
        {/* Background Image - Melhor qualidade e enquadramento usando img tag */}
        < img
          src={service.image}
          alt={service.title}
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            objectPosition: (service as any).imagePosition || 'center center',
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
          }}
          loading="eager"
        />
        {/* Filtro escuro para destacar o texto */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Headline e Subheadline sobre a imagem */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4"
            style={{
              textShadow: '0 0 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.6), 0 2px 8px rgba(0, 0, 0, 0.8)'
            }}
          >
            {tituloPagina}
          </h1>
          <p
            className="text-lg sm:text-xl md:text-2xl text-white font-semibold"
            style={{
              textShadow: '0 0 8px rgba(0, 0, 0, 0.8), 0 0 15px rgba(0, 0, 0, 0.6), 0 2px 4px rgba(0, 0, 0, 0.8)'
            }}
          >
            {service.subtitle}
          </p>
        </div>
      </section >

      {/* Botões abaixo da capa */}
      < section className="py-8 bg-white border-b border-gray-200" >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href={`tel:${siteConfig.phone}`}
              onClick={handlePhoneClick}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-8 rounded-lg transition-colors inline-flex items-center gap-2 text-lg shadow-lg hover:shadow-xl"
            >
              <i className="ri-phone-line"></i>
              Ligar agora: {siteConfig.phoneDisplay}
            </a>
            {temBlocosEscaneaveis ? (
              /* Leva ao formulário: o botão prometia orçamento mas abria o telefone */
              <button
                type="button"
                onClick={irParaOrcamento}
                className="bg-white hover:bg-gray-50 text-blue-600 font-semibold py-4 px-8 rounded-lg transition-colors inline-flex items-center gap-2 border-2 border-blue-600 text-lg shadow-lg hover:shadow-xl"
              >
                <i className="ri-mail-send-line"></i>
                Pedir um orçamento
              </button>
            ) : (
              <a
                href={`tel:${siteConfig.phone}`}
                onClick={handlePhoneClick}
                className="bg-white hover:bg-gray-50 text-blue-600 font-semibold py-4 px-8 rounded-lg transition-colors inline-flex items-center gap-2 border-2 border-blue-600 text-lg shadow-lg hover:shadow-xl"
              >
                <i className="ri-phone-line"></i>
                Pedir um orçamento
              </a>
            )}
          </div>
        </div>
      </section >

      {/* Abertura: um parágrafo só. O texto completo fica no fim da página. */}
      {
        temBlocosEscaneaveis && (
          <section className="py-10 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              {zona && (
                <nav className="text-sm text-gray-500 mb-4" aria-label="Navegação">
                  <Link to="/" className="hover:text-blue-700">Início</Link>
                  <span className="mx-2">/</span>
                  <Link to={`/ar-condicionado-${zona.slug}`} className="hover:text-blue-700">{zona.nome}</Link>
                  <span className="mx-2">/</span>
                  <span className="text-gray-700">{(service as any).navTitle}</span>
                </nav>
              )}
              <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
                {zona
                  ? zona.notasPorServico?.[id as string] || paragrafoIntro || service.description
                  : paragrafoIntro || service.description}
              </p>
            </div>
          </section>
        )
      }

      {/* Contexto local: só nas páginas de serviço numa zona */}
      {
        zona && (
          <section className="py-16 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                O que muda {zona.preposicao} {zona.nome}
              </h2>

              <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-10">
                <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
                  <div className="flex items-center gap-3 mb-4">
                    <i className="ri-building-line text-3xl text-blue-600"></i>
                    <h3 className="text-xl font-bold text-gray-900">O edificado</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{zona.edificado}</p>
                </div>

                <div className="bg-blue-600 rounded-2xl p-8 text-white">
                  <div className="flex items-center gap-3 mb-4">
                    <i className="ri-alert-line text-3xl text-blue-100"></i>
                    <h3 className="text-xl font-bold">O que costuma condicionar</h3>
                  </div>
                  <ul className="space-y-3">
                    {zona.desafios.map((desafio: string, index: number) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-xl text-blue-200 mt-0.5 shrink-0"></i>
                        <span className="text-blue-50 leading-relaxed">{desafio}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Zonas cobertas e ligação aos restantes serviços da localidade */}
              <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  Onde atuamos {zona.preposicao} {zona.nome}
                </h3>
                <div className="flex flex-wrap gap-2 mb-8">
                  {zona.bairros.map((bairro: string) => (
                    <span key={bairro} className="px-3 py-1.5 bg-white text-gray-700 rounded-full text-sm border border-gray-200">
                      {bairro}
                    </span>
                  ))}
                </div>

                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  Outros serviços {zona.preposicao} {zona.nome}
                </h3>
                <div className="flex flex-wrap gap-3">
                  {climatizacaoServicesList
                    .filter((outro) => outro.id !== id)
                    .map((outro) => (
                      <Link
                        key={outro.id}
                        to={`/${outro.slug}-${zona.slug}`}
                        className="px-4 py-2 bg-white hover:bg-blue-50 hover:text-blue-700 text-gray-700 rounded-lg text-sm border border-gray-200 transition-colors"
                      >
                        {outro.navTitle}
                      </Link>
                    ))}
                  <Link
                    to={`/ar-condicionado-${zona.slug}`}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm transition-colors inline-flex items-center gap-2"
                  >
                    Ar condicionado {zona.preposicao} {zona.nome}
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* Descrição completa */}
      {!temBlocosEscaneaveis && (
      < section className="py-12 bg-gray-50" >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {service && 'fullContent' in service && (service as any).fullContent ? (
              <div className="text-lg text-gray-700 leading-relaxed whitespace-pre-line">
                {(service as any).fullContent.split('\n\n').map((paragraph: string, index: number) => (
                  <p key={index} className="mb-4">
                    {paragraph.split('\n').map((line: string, lineIndex: number) => (
                      <span key={lineIndex}>
                        {line}
                        {lineIndex < paragraph.split('\n').length - 1 && <br />}
                      </span>
                    ))}
                  </p>
                ))}
              </div>
            ) : (
              <p className="text-lg text-gray-700 leading-relaxed text-center">
                {service.description}
              </p>
            )}
          </div>
        </div>
      </section >
      )}

      {/* Benefícios + o que está incluído, lado a lado */}
      {
        (service as any).beneficios && (service as any).beneficios.length > 0 && (
          <section className="py-16 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
                {/* Benefícios - o que o cliente ganha */}
                <div className="bg-blue-600 rounded-2xl p-8 text-white shadow-xl">
                  <div className="flex items-center gap-3 mb-6">
                    <i className="ri-award-line text-3xl text-blue-100"></i>
                    <h2 className="text-2xl font-bold">Benefícios do serviço</h2>
                  </div>
                  <ul className="space-y-4">
                    {((service as any).beneficios as string[]).map((beneficio: string, index: number) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-check-line text-xl text-blue-200 mt-0.5 shrink-0"></i>
                        <span className="text-blue-50 leading-relaxed">{beneficio}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Características - o que está tecnicamente incluído */}
                <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
                  <div className="flex items-center gap-3 mb-6">
                    <i className="ri-tools-line text-3xl text-blue-600"></i>
                    <h2 className="text-2xl font-bold text-gray-900">O que está incluído</h2>
                  </div>
                  <ul className="space-y-4">
                    {(service.features || []).map((feature: string, index: number) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-line text-xl text-blue-600 mt-0.5 shrink-0"></i>
                        <span className="text-gray-700 leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href={`tel:${siteConfig.phone}`}
                    onClick={handlePhoneClick}
                    className="mt-8 w-full bg-white hover:bg-gray-50 text-blue-600 font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center justify-center gap-2 border-2 border-blue-600"
                  >
                    <i className="ri-phone-line"></i>
                    Pedir avaliação técnica
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* Categorias / gama de produtos - grelha compacta no alphaclean.pt,
          imagem ao lado do texto nos restantes sites */}
      {
        (service as any).categorias && (service as any).categorias.length > 0 && (
          <section className={`${isCleanSite ? 'py-16' : 'py-20'} bg-gray-50`}>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  {(service as any).categoriasTitle || 'A nossa gama'}
                </h2>
                {(service as any).categoriasSubtitle && (
                  <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                    {(service as any).categoriasSubtitle}
                  </p>
                )}
              </div>

              {/* alphaclean.pt: grelha compacta com ícones, duas colunas.
                  Os outros sites mantêm o bloco largo com foto ao lado do texto. */}
              {isCleanSite ? (
                <div className="grid md:grid-cols-2 gap-6">
                  {((service as any).categorias as any[]).map((categoria: any, index: number) => (
                    <div
                      key={index}
                      className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col"
                    >
                      <div className="flex items-start gap-4 mb-4">
                        <div className="w-12 h-12 shrink-0 rounded-xl bg-blue-50 flex items-center justify-center">
                          <i className={`${categoria.icon} text-2xl text-blue-600`}></i>
                        </div>
                        <h3 className="text-lg font-bold text-gray-900 leading-snug pt-1.5">
                          {categoria.title}
                        </h3>
                      </div>

                      <p className="text-sm text-gray-600 leading-relaxed mb-4">
                        {categoria.description}
                      </p>

                      <ul className="space-y-2 mb-5">
                        {(categoria.itens || []).map((item: string, itemIndex: number) => (
                          <li key={itemIndex} className="flex items-start gap-2 text-sm text-gray-700">
                            <i className="ri-check-line text-blue-600 mt-0.5 shrink-0"></i>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>

                      <a
                        href={`tel:${siteConfig.phone}`}
                        onClick={handlePhoneClick}
                        className="mt-auto inline-flex items-center gap-2 text-blue-600 font-semibold text-sm hover:text-blue-700 transition-colors"
                      >
                        Pedir informações
                        <i className="ri-arrow-right-line"></i>
                      </a>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="space-y-8">
                  {((service as any).categorias as any[]).map((categoria: any, index: number) => (
                    <div
                      key={index}
                      className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-shadow overflow-hidden"
                    >
                      <div className={`flex flex-col md:flex-row ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>
                        {/* Visual: foto quando existe, painel com ícone quando não */}
                        <div className="md:w-2/5 shrink-0">
                          {categoria.image ? (
                            <img
                              src={categoria.image}
                              alt={categoria.title}
                              className="w-full h-56 md:h-full object-cover"
                              loading="lazy"
                            />
                          ) : (
                            <div className="w-full h-56 md:h-full min-h-[14rem] bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center">
                              <i className={`${categoria.icon} text-7xl text-blue-500`}></i>
                            </div>
                          )}
                        </div>

                        {/* Texto ao lado */}
                        <div className="md:w-3/5 p-6 sm:p-8">
                          <div className="flex items-center gap-3 mb-3">
                            <i className={`${categoria.icon} text-2xl text-blue-600`}></i>
                            <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
                              {categoria.title}
                            </h3>
                          </div>
                          <p className="text-gray-600 leading-relaxed mb-5">
                            {categoria.description}
                          </p>

                          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mb-6">
                            {(categoria.itens || []).map((item: string, itemIndex: number) => (
                              <li key={itemIndex} className="flex items-start gap-2 text-sm text-gray-700">
                                <i className="ri-check-line text-blue-600 mt-0.5 shrink-0"></i>
                                <span>{item}</span>
                              </li>
                            ))}
                          </ul>

                          <a
                            href={`tel:${siteConfig.phone}`}
                            onClick={handlePhoneClick}
                            className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition-colors"
                          >
                            Pedir informações sobre {categoria.title}
                            <i className="ri-arrow-right-line"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Fecho da secção de gama */}
              <div className="mt-12 bg-white rounded-2xl border border-gray-200 p-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Não encontrou o que procura?
                </h3>
                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                  Trabalhamos com uma gama muito mais alargada do que a listada aqui.
                  Diga-nos o que precisa e encontramos a solução certa para o seu espaço.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a
                    href={`tel:${siteConfig.phone}`}
                    onClick={handlePhoneClick}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors inline-flex items-center justify-center gap-2"
                  >
                    <i className="ri-phone-line"></i>
                    Ligar: {siteConfig.phoneDisplay}
                  </a>
                  <a
                    href="#orcamento"
                    className="bg-white hover:bg-gray-50 text-blue-600 font-semibold py-3 px-8 rounded-lg transition-colors inline-flex items-center justify-center gap-2 border-2 border-blue-600"
                  >
                    <i className="ri-mail-send-line"></i>
                    Pedir orçamento gratuito
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* Features Section - só nos sites que não usam o bloco de benefícios */}
      {
        !(service as any).beneficios && service.features && service.features.length > 0 && (
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                O que incluímos neste serviço
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {(service.features || []).map((feature: string, index: number) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                    <div className="flex items-center gap-3">
                      <i className="ri-checkbox-circle-line text-blue-600 text-2xl"></i>
                      <span className="font-medium text-gray-800">{feature}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )
      }

      {/* Sub-services Section */}
      {(service as any).subServices && (
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-16">
              Nossos Serviços Especializados
            </h2>
            <div className="space-y-20">
              {(service as any).subServices.map((sub: any, index: number) => (
                <div
                  key={index}
                  className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
                >
                  <div className="w-full lg:w-1/2">
                    <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                      <img
                        src={sub.image}
                        alt={sub.title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 space-y-6">
                    <h3 className="text-2xl font-bold text-gray-900">
                      {sub.title}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed">
                      {sub.description}
                    </p>
                    <button
                      onClick={() => document.getElementById('orcamento')?.scrollIntoView({ behavior: 'smooth' })}
                      className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition-colors"
                    >
                      Pedir Orçamento <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}


      {/* Como Trabalhamos (Custom Steps) */}
      {
        (service as any).steps && (
          <HowItWorks steps={(service as any).steps} />
        )
      }

      {/* FAQs */}
      {
        (service as any).faqs && (
          <FAQSection faqs={(service as any).faqs} />
        )
      }

      {/* Texto completo, recolhido por omissão. Fica no DOM para SEO
          sem empurrar o conteúdo escaneável para baixo. */}
      {
        temBlocosEscaneaveis && paragrafosRestantes.length > 0 && (
          <section className="py-12 bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <details className="group border border-gray-200 rounded-2xl overflow-hidden">
                <summary className="cursor-pointer list-none px-6 py-5 bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between gap-4">
                  <span className="text-lg font-semibold text-gray-900">
                    Saber mais sobre {service.navTitle ? service.navTitle.toLowerCase() : 'este serviço'}
                  </span>
                  <i className="ri-arrow-down-s-line text-2xl text-blue-600 transition-transform group-open:rotate-180 shrink-0"></i>
                </summary>
                <div className="px-6 py-6 text-gray-700 leading-relaxed space-y-4">
                  {paragrafosRestantes.map((paragrafo: string, index: number) => (
                    <p key={index}>{paragrafo}</p>
                  ))}
                </div>
              </details>
            </div>
          </section>
        )
      }

      {/* Testimonials */}
      <div id="avaliacoes">
        {(service as any).testimonials ? (
          <Testimonials testimonials={(service as any).testimonials} />
        ) : (
          <Testimonials />
        )}
      </div>

      {/* Tipos de Desentupimentos - Apenas para desentupimentos */}
      {
        id === 'desentupimentos' && (
          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
                Tipos de Desentupimentos em {cityName}
              </h2>
              <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
                Residenciais e Comerciais - Resolvemos todos os tipos de entupimentos com equipamento profissional
              </p>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* 1. Desentupimento de Esgotos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-drag-move-2-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Desentupimento de Esgotos</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    O mais comum em residências e prédios. Envolve a limpeza e desobstrução de canos, colunas e caixas de esgoto.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Esgoto de cozinha entupido</li>
                    <li>• Esgoto de banheiro entupido</li>
                    <li>• Esgoto de lavandaria</li>
                    <li>• Colunas verticais de prédios</li>
                  </ul>
                </div>

                {/* 2. Desentupimento de Sanitas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-home-4-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Desentupimento de Sanitas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Entupimentos causados por papel, objetos ou excesso de resíduos. Resolvemos rapidamente.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Sanita entupida com papel ou objetos</li>
                    <li>• Sanita a transbordar</li>
                    <li>• Autoclismo sem descarga</li>
                    <li>• Retorno de água</li>
                  </ul>
                </div>

                {/* 3. Desentupimento de Lavatórios e Pias */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-drop-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Lavatórios e Pias</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Problema típico de acumulação de gordura, cabelo e sabão nos canos.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Pia da cozinha com retorno</li>
                    <li>• Lavatório de casa de banho entupido</li>
                    <li>• Tubos com gordura endurecida</li>
                  </ul>
                </div>

                {/* 4. Desentupimento de Ralos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-water-percent-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Desentupimento de Ralos</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Ralos de duche, cozinha e varanda frequentemente acumulam cabelo, sabão e detritos.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Ralo de duche ou banheira</li>
                    <li>• Ralo de piso de cozinha</li>
                    <li>• Ralo de lavandaria</li>
                    <li>• Eliminação de mau cheiro</li>
                  </ul>
                </div>

                {/* 5. Desentupimento de Sifões */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-settings-3-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Desentupimento de Sifões</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Pequenas curvas nos canos que acumulam resíduos e odores.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Limpeza de sifões metálicos ou PVC</li>
                    <li>• Substituição de sifões danificados</li>
                    <li>• Eliminação de mau cheiro</li>
                  </ul>
                </div>

                {/* 6. Colunas de Prédios */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-building-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Colunas de Prédios</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Problemas de entupimento que afetam vários apartamentos ao mesmo tempo.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Limpeza de colunas de esgoto</li>
                    <li>• Desobstrução com sonda elétrica</li>
                    <li>• Inspeção com câmera para condomínios</li>
                  </ul>
                </div>

                {/* 7. Fossas Sépticas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-tank-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Fossas Sépticas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Limpeza e desobstrução de fossas residenciais e comerciais.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Aspiração e limpeza total</li>
                    <li>• Remoção de resíduos sólidos</li>
                    <li>• Manutenção preventiva</li>
                  </ul>
                </div>

                {/* 8. Canos Externos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-road-map-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Canos Externos</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Bloqueios em áreas externas causados por folhas, lama e detritos.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Limpeza de tubos pluviais</li>
                    <li>• Desentupimento de calhas</li>
                    <li>• Eliminação em quintais</li>
                  </ul>
                </div>

                {/* 9. Caixas de Gordura */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-box-3-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Caixas de Gordura</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Essencial para cozinhas domésticas e restaurantes.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Remoção de gordura solidificada</li>
                    <li>• Limpeza completa</li>
                    <li>• Prevenção de entupimentos</li>
                  </ul>
                </div>

                {/* 10. Industrial e Comercial */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-store-3-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Industrial e Comercial</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Serviços para empresas, hotéis, condomínios, fábricas e restaurantes.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Limpeza de redes industriais</li>
                    <li>• Cozinhas industriais</li>
                    <li>• Intervenções noturnas</li>
                  </ul>
                </div>

                {/* 11. Inspeção por Câmera */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-camera-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Inspeção por Câmera</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Diagnóstico de entupimentos complexos com tecnologia visual.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Filmagem interna dos canos</li>
                    <li>• Identificação do ponto exato</li>
                    <li>• Relatório técnico preciso</li>
                  </ul>
                </div>

                {/* 12. Urgência 24h */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-time-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Urgência 24h</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Serviço disponível a qualquer hora, inclusive fins de semana e feriados.
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Atendimento imediato</li>
                    <li>• Equipa de plantão noturno</li>
                    <li>• Resolução de emergências</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* Problemas que Indicam Fuga de Água - Apenas para fugas no site alphacanalizacoes.pt */}
      {
        id === 'fugas' && !isDesentupimentosSite && (
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
                Problemas que Indicam Fuga de Água
              </h2>
              <p className="text-lg text-gray-600 mb-8 text-center max-w-3xl mx-auto">
                Nem sempre uma fuga é visível, mas os sinais costumam estar por perto. Estes são os sintomas mais comuns de fugas de água em residências, condomínios e empresas:
              </p>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto mb-8">
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">A conta de água aumentou sem motivo aparente</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Manchas de humidade em paredes, tetos ou chão</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">O contador continua a girar mesmo com todas as torneiras fechadas</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">O piso está quente, húmido ou com bolhas</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Ouve som de água a correr, mesmo quando não há consumo</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Cheiro de mofo persistente em divisões próximas a canalizações</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Perda de pressão na água da torneira ou do duche</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Pintura descascando ou azulejos soltos em áreas húmidas</span>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-line text-blue-600 text-xl mt-1"></i>
                    <span className="text-gray-800">Aparecimento de fungos ou manchas escuras nas paredes</span>
                  </div>
                </div>
              </div>

              <div className="bg-blue-600 rounded-lg p-6 text-center max-w-3xl mx-auto">
                <p className="text-white text-lg mb-4">
                  Se algum desses sinais aparece na sua casa, há uma fuga oculta.
                </p>
                <a
                  href={`tel:${siteConfig.phone}`}
                  onClick={handlePhoneClick}
                  className="bg-white text-blue-600 hover:bg-gray-100 font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-phone-line"></i>
                  Ligue para {siteConfig.phoneDisplay}
                </a>
                <p className="text-white/90 text-sm mt-4">
                  A Alpha Canalizações faz deteção imediata com diagnóstico técnico no local, sem destruir nada e com garantia no serviço.
                </p>
              </div>
            </div>
          </section>
        )
      }

      {/* Tipos de Fugas de Água - Apenas para fugas no site alphacanalizacoes.pt */}
      {
        id === 'fugas' && !isDesentupimentosSite && (
          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
                Tipos de Fugas de Água em {cityName}
              </h2>
              <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
                As fugas podem ocorrer em vários pontos do sistema hidráulico. Abaixo listamos todos os tipos de fuga que diagnosticamos e reparamos diariamente em {cityName} e arredores:
              </p>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* 1. Fugas em Paredes */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-home-4-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Fugas em Paredes</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    São fugas internas causadas por tubos embutidos que se rompem com o tempo ou devido a pressão excessiva.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Manchas de humidade</li>
                    <li>• Bolhas na tinta</li>
                    <li>• Mofo no gesso</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Deteção com câmara térmica e reparação localizada sem quebra excessiva.</p>
                </div>

                {/* 2. Fugas em Pisos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-layout-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Fugas em Pisos</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Fugas sob o chão geralmente vêm de tubos de água quente, provocando aquecimento do piso ou deformação do revestimento.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Mais comuns em:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Sistemas de aquecimento</li>
                    <li>• Cozinhas e casas de banho</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Inspeção por termografia e reparo com isolamento térmico.</p>
                </div>

                {/* 3. Fugas em Tetos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-building-2-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Fugas em Tetos</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Ocorrem quando a canalização do andar superior está danificada.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Manchas escuras no teto</li>
                    <li>• Goteiras</li>
                    <li>• Humidade constante</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Localização com sensor acústico e reparação imediata no ponto exato.</p>
                </div>

                {/* 4. Fugas em Canalizações Embutidas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-tools-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Canalizações Embutidas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Fugas ocultas em paredes, pisos ou lajes de betão.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Causas:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Vibração, corrosão</li>
                    <li>• Solda defeituosa</li>
                    <li>• Tubagens antigas</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Gás traçador e endoscopia hidráulica para localização precisa.</p>
                </div>

                {/* 5. Fugas em Autoclismos */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-home-4-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Autoclismos e Descargas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Autoclismos com fugas constantes aumentam o consumo de água até 200 litros por dia.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Água a correr continuamente</li>
                    <li>• Ruído constante após descarga</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Substituição de vedantes e mecanismos internos.</p>
                </div>

                {/* 6. Fugas em Torneiras */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-drop-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Torneiras e Misturadoras</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Geralmente visíveis, mas ignoradas por muito tempo.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Pinga-pinga constante</li>
                    <li>• Perda de pressão</li>
                    <li>• Corrosão no bico</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Troca de anéis de vedação, cartuchos e conexões.</p>
                </div>

                {/* 7. Fugas em Canalizações Externas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-road-map-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Canalizações Externas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Comuns em quintais, jardins e áreas técnicas.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Áreas encharcadas</li>
                    <li>• Poças de água</li>
                    <li>• Crescimento de musgo</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Localização com sensor de solo e reparação direta no ponto afetado.</p>
                </div>

                {/* 8. Fugas Subterrâneas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-landscape-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Canalizações Subterrâneas</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Fugas de grande volume e difícil acesso, normalmente em tubagens principais de abastecimento.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Perda de pressão generalizada</li>
                    <li>• Consumo constante</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Deteção com gás traçador e reparação com substituição de trechos.</p>
                </div>

                {/* 9. Fugas em Aquecedores */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-fire-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Aquecedores e Termoacumuladores</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Podem causar infiltração e curto-circuitos.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Humidade na base</li>
                    <li>• Água acumulada no chão</li>
                    <li>• Ruídos incomuns</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Isolamento do circuito, reparação ou substituição do equipamento.</p>
                </div>

                {/* 10. Fugas em Piscinas */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-water-percent-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Piscinas e Reservatórios</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Perdas de água lentas e constantes.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Sinais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Queda no nível da piscina</li>
                    <li>• Rachaduras</li>
                    <li>• Humidade no entorno</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Teste de pressão e inspeção com corante e câmara subaquática.</p>
                </div>

                {/* 11. Fugas Industriais */}
                <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3 mb-3">
                    <i className="ri-store-3-line text-blue-600 text-2xl mt-1"></i>
                    <h3 className="text-xl font-bold text-gray-900">Redes Comerciais e Industriais</h3>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Tubulações de grande diâmetro e alta pressão.
                  </p>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Locais:</p>
                  <ul className="text-sm text-gray-600 space-y-1 mb-3">
                    <li>• Hotéis, condomínios</li>
                    <li>• Restaurantes e fábricas</li>
                  </ul>
                  <p className="text-sm font-semibold text-gray-700 mb-2">Solução:</p>
                  <p className="text-sm text-gray-600">Monitoramento técnico, reparo programado e relatórios para manutenção preventiva.</p>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* Por Que Escolher - Apenas para fugas no site alphacanalizacoes.pt */}
      {
        id === 'fugas' && !isDesentupimentosSite && (
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                Por Que Escolher a Alpha Canalizações
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
                <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <i className="ri-tools-line text-blue-600 text-3xl"></i>
                    <h3 className="text-xl font-bold text-gray-900">Localização sem Destruição</h3>
                  </div>
                  <p className="text-gray-600">Localizamos fugas sem destruir paredes ou pisos</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <i className="ri-checkbox-circle-line text-blue-600 text-3xl"></i>
                    <h3 className="text-xl font-bold text-gray-900">Equipamentos Modernos</h3>
                  </div>
                  <p className="text-gray-600">Trabalhamos com equipamentos modernos e certificados</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <i className="ri-file-text-line text-blue-600 text-3xl"></i>
                    <h3 className="text-xl font-bold text-gray-900">Relatórios Técnicos</h3>
                  </div>
                  <p className="text-gray-600">Relatórios técnicos detalhados para seguros e condomínios</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <i className="ri-24-hours-line text-blue-600 text-3xl"></i>
                    <h3 className="text-xl font-bold text-gray-900">Atendimento 24h</h3>
                  </div>
                  <p className="text-gray-600">Atendimento 24h em {cityName} e arredores</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <i className="ri-user-star-line text-blue-600 text-3xl"></i>
                    <h3 className="text-xl font-bold text-gray-900">Técnicos Experientes</h3>
                  </div>
                  <p className="text-gray-600">Técnicos formados com mais de 15 anos de experiência</p>
                </div>
              </div>
            </div>
          </section>
        )
      }

      {/* How It Works - só quando o serviço não traz passos próprios (evita repetir a secção) */}
      {!(service as any).steps && <HowItWorks />}

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* Form at the end of the page */}
      <section className="py-16 bg-gray-50" id="orcamento">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <QuoteForm />
          </div>
        </div>
      </section>

      {/* Zonas Atendidas */}
      <div id="zonas">
        <ServiceAreas />
      </div>

      {!isClimatizacaoSite && <FloatingAI />}
      <FloatingWhatsApp />
      <Footer />
    </div >
  );
};

export default Servico;

